'use client';

import { createContext, useContext } from 'react';

// Populated once by a server component (src/app/(public)/layout.js) from
// @/lib/live-routes.server's LIVE_PATHS — the same registries that drive
// actual routing — and handed down as a plain array so any client component
// (HeaderClient, Footer, HireSection) can filter/redirect dead links via
// @/lib/live-nav without each needing its own server import.
const LiveNavContext = createContext([]);

export function LiveNavProvider({ livePaths, children }) {
  return (
    <LiveNavContext.Provider value={livePaths}>
      {children}
    </LiveNavContext.Provider>
  );
}

export function useLivePaths() {
  return useContext(LiveNavContext);
}
